import { render } from "./EditLabel.vue?vue&type=template&id=64020c41&scoped=true"
import script from "./EditLabel.vue?vue&type=script&lang=js"
export * from "./EditLabel.vue?vue&type=script&lang=js"

import "./EditLabel.vue?vue&type=style&index=0&id=64020c41&scoped=true&lang=css"

import exportComponent from "D:\\Vue-Project\\Darli-Gallery\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64020c41"]])

export default __exports__